export default __webpack_public_path__ + "static/media/ZWIVEL.1cf1269c.png";